import ArrowInventory from './component'

export default ArrowInventory
